import React from 'react'
import Image from 'components/image/image'
import './block-accordion.sass'

function handleClick (event) {
    const wrapper = event.target.parentNode.previousElementSibling;
    event.target.classList.toggle("active");
    wrapper.classList.toggle("active");

    if (wrapper.style.maxHeight) {
      wrapper.style.maxHeight = null;
    } else {
      wrapper.style.maxHeight = wrapper.scrollHeight + "px";
    }
}

const getImage = (img) => (
  <div className="BlockAccordion__content k-max-width--1">
    <Image image_url={`content/${img}`}
           className="img-fluid"
           alt={img} />
  </div>
)

const getMarkDown = (md) => (
  <div
    className="BlockAccordion__content"
    dangerouslySetInnerHTML={{ __html: md }} />
)

const getContent = (contents) => {
  return contents.map((content, i) => {
    return (
      <React.Fragment key={i}>
        {
          content.indexOf('/content/') > -1
            ? getImage(content.split('/content/').pop(1))
            : getMarkDown(content)
        }
      </React.Fragment>
    )
  })
}

const BlockAccordion = ({ data }) => {
  return (
    <section className={`
      BlockAccordion
      ${data.classes? data.classes : ''}
    `}>
      <div className="container-fluid">
        <div className="BlockAccordion__wrapper k-bg--grey">
          {getContent(data.content)}
        </div>
        <div className="BlockAccordion__expand-wrapper">
          <div className="BlockAccordion__expand-button" onClick={(e) => handleClick(e)}> section</div>
        </div>
      </div>
    </section>
  )
}

export default BlockAccordion

